import React from "react";
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import {
    CURRENCIES, PRODUCT_COST_PAGE_NAME, LIST_PRODUCT_COST_CELLS,
} from "../constants";
import withShipment from "../../../withShipment";
import {TableCell} from "@mui/material";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import TablePage from "../../global/Table/TablePage";
import {Filter} from "../../global/Table/TablePageHelpers/FilterObject";
import "./ProductCostsTable.css"
import LocationSelectBox from "../../global/subcomponents/locationSelectBox/LocationSelectBox";
import { BACK } from '../../invoices/carrierInvoices/constants';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import SettingsIcon from '@material-ui/icons/Settings';
import { IconButton, TextField, Tooltip } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import {
  BOX_COST_INFO_PART1, BOX_COST_INFO_PART2,
  OPTIONS,
  PRODUCT_COST_AVERAGE_INFO_PART1, PRODUCT_COST_AVERAGE_INFO_PART2,
  SHIPPING_COST_INFO,
} from '../../automationrules/AutomationSettings/constants';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Autocomplete from '@material-ui/lab/Autocomplete';

class ProductCostTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteId: "",
            carrierOptions: [],
            isSettingPage: false,
            selectedStatus: false,
            otherCostStatus: false,
            productCostFromDate: '1',
            boxCostFromDate: '1',
            ftlCostFromDate: '',
            otherCostText: '0.00',
            percentageCostText: '',
            dollarCostText: '',
            referralFeeText: '15',
            boxAverageCost: '',
            currencyRates:[],
            defaultCurrency: "",
            shippingCostFromDate: '1',
        }
    }

    componentDidMount() {
        this.updateState()

    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if(prevProps.carriers !== this.props.carriers) {
            this.setState({
                carrierOptions: this.props.carriers
            })
        }

        if(prevProps.automationSettings !== this.props.automationSettings) {
            this.updateState()
        }
    }


    setIsSettingPage = (bool) => {
      this.setState({ isSettingPage: bool });
    };

    updateHandler = () => {
        let inputObject = {};
        let boxDateRange = {};
        let ftlDateRange = {};
        let productDateRange = {};
        let shippingDateRange = {};
        productDateRange["fromDate"] = this.state.productCostFromDate;
        boxDateRange["fromDate"] = this.state.boxCostFromDate;
        ftlDateRange["fromDate"] = this.state.ftlCostFromDate;
        shippingDateRange["fromDate"] = this.state.shippingCostFromDate;
        inputObject["accountForProfitOrLoss"] = this.state.selectedStatus;
        inputObject["productCostDateRange"] = productDateRange;
        inputObject["boxCostDateRange"] = boxDateRange;
        inputObject["ftlCostDateRange"] = ftlDateRange;
        inputObject["shippingCostDateRange"] = shippingDateRange;
        inputObject["otherCosts"] = this.state.otherCostStatus;
        inputObject["otherCostText"] = this.state.otherCostText;
        inputObject["referralFee"] = this.state.referralFeeText;
        inputObject["currencyRates"] = this.state.currencyRates;
        inputObject["defaultCurrency"] = this.state.defaultCurrency;
        this.props.updateCompany({
            companyId: this.props.user.company,
            automationSetting: inputObject,
        });
    }

    updateState = () => {
        this.setState({
            selectedStatus: this.props?.automationSettings?.accountForProfitOrLoss === undefined ? false : this.props?.automationSettings?.accountForProfitOrLoss,
            otherCostStatus: this.props?.automationSettings?.otherCosts === undefined ? false : this.props?.automationSettings?.otherCosts,
            productCostFromDate: this.props?.automationSettings?.productCostDateRange?.fromDate === undefined ? "1" : this.props?.automationSettings?.productCostDateRange?.fromDate,
            boxCostFromDate: this.props?.automationSettings?.boxCostDateRange?.fromDate === undefined ? "1" : this.props?.automationSettings?.boxCostDateRange?.fromDate,
            ftlCostFromDate: this.props?.automationSettings?.ftlCostDateRange?.fromDate === undefined ? "" : this.props?.automationSettings?.ftlCostDateRange?.fromDate,
            shippingCostFromDate: this.props?.automationSettings?.shippingCostDateRange?.fromDate === undefined ? "" : this.props?.automationSettings?.shippingCostDateRange?.fromDate,
            otherCostText: this.props?.automationSettings?.otherCostText === undefined ? "0.00" : this.props.automationSettings?.otherCostText,
            referralFeeText: this.props?.automationSettings?.referralFee === undefined ? "15" : this.props?.automationSettings?.referralFee,
            currencyRates: this.props?.automationSettings?.currencyRates === undefined ? [] : this.props?.automationSettings?.currencyRates,
            defaultCurrency: this.props?.automationSettings?.defaultCurrency === undefined ? [] : this.props?.automationSettings?.defaultCurrency
        });
    }


    handleProductDateChange = async (date, fromOrTo) => {
        if(fromOrTo === 'from') {
            await this.setState({
                productCostFromDate: date
            });
        }
        this.updateHandler();
    }

       handleBoxDateChange = async (date, fromOrTo) => {
        if(fromOrTo === 'from') {
            await this.setState({
                boxCostFromDate: date
            });
        }
        this.updateHandler();
    }



    getTableHeaders = () => {
        let headers = []
        headers.push(Layout.columnHead(null,null,null))
        LIST_PRODUCT_COST_CELLS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id, "left"))
        })
        return headers
    }

    tableRow = (row, index) => {
        return <React.Fragment>
            <TableCell />
            <TableCell align="left" style={{paddingLeft: 5}}> {row?.shortcode} </TableCell>
            <TableCell align="left"> {row?.averageCost ? "$" + parseFloat(row?.averageCost.toString()).toFixed(2) : ""} </TableCell>
            <TableCell align="left"> {row?.currency} </TableCell>
        </React.Fragment>
    }

    userHasAutomationSettingPermission = () => {
       const userRoutes = this.props.user?.routes || []
       return userRoutes.includes('automation-settings')
    }

    render() {
        const menuItems = [];

        if (this.state.isSettingPage) {
          menuItems.push({
            title: 'Back',
            icon: <KeyboardBackspaceIcon />,
            onClick: () => {
              this.setIsSettingPage(false);
            },
          });
        } else if (this.userHasAutomationSettingPermission()) {
          menuItems.push({
            title: 'Settings',
            icon: <SettingsIcon />,
            onClick: () => {
              this.setIsSettingPage(true);
            },
          });
        }

        return (
            <React.Fragment>
                <TopToolbar
                    pageName={this.state.isSettingPage ? 'Settings' :PRODUCT_COST_PAGE_NAME}
                     menuItems={menuItems}
                />

                {this.state.isSettingPage ? (
                  <div style={{ marginTop: '24px', marginLeft: '24px' }}>
                    <div className="other-margin">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TextField
                          label="Product Cost"
                          InputProps={{
                            disabled: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  enterTouchDelay={0}
                                  leaveTouchDelay={30000}
                                  enterDelay={400}
                                  // leaveDelay={1000000} // for testing purposes
                                  title={
                                    <React.Fragment>
                                      <p>{PRODUCT_COST_AVERAGE_INFO_PART1}</p>
                                      <p>{PRODUCT_COST_AVERAGE_INFO_PART2}</p>
                                    </React.Fragment>
                                  }
                                >
                                  <IconButton aria-label="info">
                                    <InfoOutlinedIcon
                                      variant="outlined"
                                      fontSize="small"
                                    />
                                  </IconButton>
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                          style={{
                            marginBottom: '5px',
                            maxWidth: '175px',
                            minWidth: '175px',
                          }}
                          InputLabelProps={{ className: 'product-label' }}
                        />
                      </div>
                      <div className="vl"></div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <Autocomplete
                          options={OPTIONS}
                          getOptionLabel={(option) => option.label}
                          className="date-box"
                          name="addTag"
                           onChange={(event, value) => {
                            if (value) {
                              this.handleProductDateChange(value.id, 'from');
                            } else {
                              this.handleProductDateChange(null, 'from');
                            }
                          }}
                          value={OPTIONS.find(
                            (opt) => opt.id === this.state.productCostFromDate
                          ) || null}
                          renderInput={(params) => (
                            <div>
                              <TextField
                                {...params}
                                label="Average Over"
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                name="addTag"
                              />
                            </div>
                          )}
                        />
                      </div>
                    </div>

                    <div className="other-margin">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TextField
                          label="Box Cost"
                          InputProps={{
                            disabled: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  enterTouchDelay={0}
                                  leaveTouchDelay={30000}
                                  enterDelay={400}
                                  // leaveDelay={1000000} // for testing purposes
                                  title={
                                    <React.Fragment>
                                      <p>{BOX_COST_INFO_PART1}</p>
                                      <p>{BOX_COST_INFO_PART2}</p>
                                    </React.Fragment>
                                  }
                                >
                                  <IconButton aria-label="info">
                                    <InfoOutlinedIcon
                                      variant="outlined"
                                      fontSize="small"
                                    />
                                  </IconButton>
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                          variant="outlined"
                          style={{
                            marginBottom: '5px',
                            maxWidth: '175px',
                            minWidth: '175px',
                          }}
                          InputLabelProps={{ className: 'box-label' }}
                        />
                      </div>
                      <div className="vl"></div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <Autocomplete
                          options={OPTIONS}
                          getOptionLabel={(option) => option.label}
                          className="date-box"
                          name="addTag"
                          onChange={(event, value) => {
                            if (value) {
                              this.handleBoxDateChange(value.id, 'from');
                            } else {
                              this.handleBoxDateChange(null, 'from');
                            }
                          }}
                          value={OPTIONS.find(
                            (opt) => opt.id === this.state.boxCostFromDate
                          ) || null}
                          renderInput={(params) => (
                            <div>
                              <TextField
                                {...params}
                                label="Average Over"
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                name="addTag"
                              />
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <TablePage
                    tableName="ProductCostTable"
                    tableRows={this.props.productCosts}
                    tableColumnHeads={this.getTableHeaders()}
                    tableRow={this.tableRow}
                    hasSearchField
                    paginationText="Products per page"
                    searchStrings={(row) => LIST_PRODUCT_COST_CELLS.map(column => row[column.id])}
                    filters={[
                      Filter.createFilter("shortcode", (row) => row.shortcode, null, Filter.relations.containedBy, true),
                      Filter.createFilter("averageCost", (row) => row.averageCost, null, Filter.relations.containedBy, true),
                      Filter.createFilter("currency", (row) => row.currency, null, Filter.relations.containedBy, true),
                    ]}
                    locationField={<LocationSelectBox />}
                    filterDropdown={Layout.newLayout(1, [
                      Layout.row([
                        Layout.rowElement(1, 'currency', 'Currency', Layout.elementStyle.checkboxDropdown, CURRENCIES)
                      ])
                    ])}
                  />
                )
                }
            </React.Fragment>
        )
    }
}

const actionCreators = {}

export default withShipment({
  actionCreators
}, ProductCostTable);